<template>

    <div class="thank-button">
        <div class="thank-you" playwright-id='thank-you'>
            <TSVG :src="$config.rfpSuccessImage" customClass="success-image" />
            <div class="thank-you-text1">
                <div class="line">{{ $translation($websiteText().checkout_submitted_successfully_first_line) }}</div>
                <div class="line">{{ $translation($websiteText().checkout_submitted_successfully_second_line) }}</div>
            </div>

            <div class="thank-you-text2">
                <div class="line">
                    {{ $translation(paymentMethodDetailed.success_message || $websiteText().checkout_submitted_successfully_third_line) }}
                </div>
                <br>
                <div class="line">{{ $translation($websiteText().checkout_submitted_successfully_fourth_line) }}</div>
            </div>
        </div>
        <div class="buttons">
            <TButton v-if="paymentMethod == 4 && invoiceGenerated == false" style="width:16rem;height:38px;margin-right:2%"
                :color="'primary-color'" buttonClass="button-class"
                :label="$translation($websiteText().checkout_submitted_successfully_download_order_confirmation)"
                @click="downloadOrderConfirmation()"></TButton>
            <TButton v-else style="width:16rem;height:38px;margin-right:2%" :color="'primary-color'"
                buttonClass="button-class"
                :label="$translation($websiteText().checkout_submitted_successfully_download_invoice)"
                :disabled="(invoiceGenerated == false)" @click="downloadInvoice()"></TButton>
            <TButton style="max-width:100%;width:12rem;height:38px;padding:10px;margin-right:2%"
                buttonClass="button-class" color='secondary-color'
                :label="$translation($websiteText().checkout_submitted_successfully_go_to_my_orders)"
                @click="goTo('Orders')"></TButton>

            <TButton style="width:16rem;height:38px;padding:10px" buttonClass="button-class" color='light-color-medium'
                :label="$translation($websiteText().checkout_submitted_successfully_look_for_another_collectible)"
                @click="goTo('Shop')"></TButton>

        </div>
    </div>


    <form method="post" id="invoice_form" :action="invoiceURL">
        <input type="hidden" name="token" :value="$store.getters.token">
    </form>


</template>

<script>

import TButton from "../../../../common/components/buttons/TButton.vue";
import axiosInstance from "../../../../common/utils/axios";
import GeneralVariables from '../../../../common/utils/GeneralVariables';
import store from "../../../../store";
import TSVG from "../../../../common/components/icons/TSVG.vue";

export default ({
    components: {
        TButton,
        TSVG
    },
    data() {
        return {
            invoiceURL: GeneralVariables.BACKEND + "api/v1.0/orders/" + this.$route.params['id'] + "/invoice" + window.location.search
        }
    },
    setup() {
        store.dispatch('getPaymentMethods')
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        goTo(page) {
            this.$router.push({ name: page });
        },
        openUrlAsBlob(url) {
            fetch(url,
                {
                    method: "GET",
                    mode: 'cors',
                    headers: {
                        "Accept": "*/*",
                    }
                }
            )
                .then(res => res.blob())
                .then(blob => {
                    let objectURL = URL.createObjectURL(blob)
                    window.open(
                        objectURL,
                        "_blank"
                    );
                });
        },
        downloadInvoice() {
            this.invoiceURL = GeneralVariables.BACKEND + "api/v1.0/orders/" + this.orderId  + "/invoice"
            let form = document.getElementById("invoice_form")
            setTimeout(() => form.submit(), 500);

        },
        downloadOrderConfirmation() {
            this.invoiceURL = GeneralVariables.BACKEND + "api/v1.0/orders/" + this.orderId  + "/invoice" + "?isproforma=1"
            let form = document.getElementById("invoice_form")
            setTimeout(() => form.submit(), 500);
        },
    },
    computed: {
        summary() {
            return this.$store.getters.summary;
        },
        orderId() {
            return this.$store.getters.orderId
        },
        paymentMethod() {
            return this.$store.getters.payment_method
        },
        paymentMethodDetailed() {
            return this.$store.getters.payment_methods.find(x => x.id == this.paymentMethod) || {}
        },
        invoiceGenerated() {
            return this.$store.getters.invoice_generated
        }
    },
    mounted() {
        window.scrollTo(0, 0)
    }

})
</script>

<style lang="scss" scoped>
.thank-button {

    padding: 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 11rem;

    .thank-you {
        display: flex;
        flex-direction: column;
        width: 80%;
        margin: 0 auto;
        padding: 10px;
        position: relative;
        background-color: rgba($tertiary-color, 0.07);
        border-radius: 4px;
        margin-bottom: 5rem;
        padding: 20px;
        max-width: 850px;



        .success-image {
            height: 56px;
            width: 56px;
            height: auto;
            margin: 0 auto;
            position: relative;
            display: flex;
            justify-content: center;
            padding-bottom: 20px;
            padding-top: 20px;
        }

        .thank-you-text1 {

            color: $tertiary-color;
            @include f-h5;
            font-size: 23px;
            height: auto;
            margin: 0 auto;
            position: relative;
            width: auto;
            margin: 10px 0 20px 0;
        }

        .thank-you-text2 {

            height: auto;
            margin: 0 auto;
            position: relative;
            width: auto;
            color: black;
            @include f-subtitle1;
            font-size: 18px;
        }
    }

    ::v-deep .buttons {
        display: flex;
        flex-direction: row;
        width: 80%;
        height: auto;
        margin: 0 auto;
        padding: 10px 0 10px 0;
        position: relative;
        margin-top: 20px;
        align-items: center;
        justify-content: space-between;



        @media screen and (max-width: 650px) {
            display: block;
            margin-top: 0;
            margin: 0 auto;
        }

        .button-class {

            @media screen and (max-width: 650px) {
                width: 16rem !important;
                margin-top: 10px;
            }
        }
    }
}

.line {
    text-align: center;
}
</style>
